<template>
    <div class="device-desktop"
        :style="{ background: 'custom' == pageSetting?.backgroundType ? pageSetting.background : '#fff' }">
        <layout :config="config.componentSetting" :showBreadcrumb>
            <slot></slot>
        </layout>
    </div>
</template>

<script setup>
import layout from './layout.vue';
import { useHomePageStore } from '~/store/homePage';

const props = defineProps({
    data: {
        type: Object,
        default: () => ({})
    },
    showBreadcrumb: {
        type: Boolean,
        default: true
    }
});

// 处理组件合并逻辑的函数
function processComponentSetting(components) {
    if (!components || !components.length) return components;
    
    const result = [];
    let obj = null;
    
    components.forEach(item => {
        // 下载组件特殊处理，合并为一组
        if (43 === item.type || 22 === item.type) {
            if (obj && obj.type === item.type) {
                obj.list.push(item);
            } else {
                if (obj) {
                    result.push(obj);
                }
                obj = {
                    ...item,
                    list: [item]
                };
            }
        } else {
            if (obj) {
                result.push(obj);
                obj = null;
            }
            result.push(item);
        }
    });
    
    if (obj) {
        result.push(obj);
    }
    
    return result;
}

const config = computed(() => {
    const parsed = JSON.parse(props.data?.content || JSON.stringify({ componentSetting: [], pageSetting: {} }));
    // PC端图文组件5连排展示处理
    parsed.componentSetting = processComponentSetting(parsed.componentSetting);
    console.log('PC端 config.value.componentSetting============', parsed.componentSetting);
    return parsed;
});

const homePageStore = useHomePageStore();
const pageSetting = config.value.pageSetting;
homePageStore.setPageSetting(pageSetting);
</script>

<style lang="scss" scoped></style>
